import styled from 'styled-components';
function Footer() {
  return (
    <Wrap>
      <p>
        서울특별시 종로구 종로 19 르메이에르종로타운 B동 925호 |
        사업자등록번호:101-11-94132 | 대표자:권오훈 | T: 02-733-7112 F:
        02-6971-9945
      </p>
      <span>© 2022 Soyoung. All Rights Reserved</span>
    </Wrap>
  );
}
const Wrap = styled.div`
  padding: 150px 0 60px;
  text-align: center;
  background: ${props => props.theme.bgColor};
  p {
    color: #7c7c9d;
    line-height: 20px;
    margin-bottom: 10px;
  }
  span {
    color: #7c7c9d;
  }
  @media only screen and (max-width: 750px) {
    padding: 80px 0;
    font-size: 14px;
  }
`;
export default Footer;
